"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var react_router_dom_1 = require("react-router-dom");
function CarsItem(_a) {
    var id = _a.id, children = _a.children;
    return (react_1.default.createElement("div", { className: "col-md-6 col-lg-4 d-md-flex" },
        react_1.default.createElement(react_router_dom_1.Link, { to: "/" + id + "/", className: "azgazui__cars-item" }, children)));
}
exports.default = CarsItem;
CarsItem.displayName = 'CarsItem';
CarsItem.propTypes = {
    id: prop_types_1.default.string.isRequired,
    children: prop_types_1.default.node.isRequired,
};
